module.exports = __webpack_public_path__ + "img/box_stopped.d11b2936.svg";